/**
 * Skeleton — Pulsing placeholder block for perceived performance during loads.
 * Variants:
 *   <Skeleton />               — single line of text
 *   <Skeleton variant="card" /> — card-shaped placeholder
 *   <SkeletonGroup count={3} /> — multiple rows
 */

export default function Skeleton({ className = '', variant = 'line', width, height }) {
  const variantClasses = {
    line: 'h-3',
    title: 'h-5',
    card: 'h-24',
    avatar: 'h-10 w-10 rounded-full',
    button: 'h-10',
  };

  return (
    <div
      className={`skeleton ${variantClasses[variant] || ''} ${className}`}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}

export function SkeletonCard({ className = '' }) {
  return (
    <div className={`bg-slate-800/40 border border-slate-700/40 rounded-lg p-4 space-y-3 ${className}`}>
      <div className="flex items-center gap-2">
        <Skeleton className="w-2.5 h-2.5 rounded-full" />
        <Skeleton variant="title" className="w-32" />
      </div>
      <div className="flex gap-4">
        <Skeleton className="w-20" />
        <Skeleton className="w-24" />
      </div>
    </div>
  );
}

export function SkeletonAction({ className = '' }) {
  return (
    <div className={`bg-slate-800/30 border border-slate-700/40 rounded-lg p-3 flex items-start gap-3 ${className}`}>
      <Skeleton className="w-5 h-5 rounded mt-0.5" />
      <div className="flex-1 space-y-2">
        <Skeleton className="w-3/4" />
        <Skeleton className="w-1/3 h-2" />
      </div>
    </div>
  );
}
